export default {
    home: {
        title: 'Dashboard',

        pending_connections: {
            invite: 'Invite colleagues to your network',
            show_more: 'and {n} more',
        },

        workboard: {
            appointment_pending: 'appointment confirmations',
            appointment_proposals: 'appointment proposals',
            proposal_acceptance: 'proposals acceptance',
            confirmation: 'confirmation',
            appointment_hint: 'Pending appointments',
            insurance_auth: 'insurance authorizations',
            no: 'No',
            insurance_auth_hint: 'Pending insurance authorizations',
            consultation_notes: 'consultation reports',
            pending: 'Pending',
            request: 'Request',
            upload: 'Upload',
            patients: 'Patients',
            didnt_show: "didn't show",
            consultation_notes_hint: 'Pending consultation reports',
            show: 'Show',
            no_show_hint: 'Patients no show',
            switch_referrals_made: 'Switch to referrals made',
            switch_referrals_received: 'Switch to referrals received',
            show_more_alerts: 'Show more alerts',
            back: 'Back',
        },
    },
}
